import { call, put, takeLatest } from "redux-saga/effects";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { rootActions } from "../../actions/rootActions";
import { eDmKhoiNganhActionIds } from "../../action-types/category/IDmKhoiNganhActions";
import { khoiNganhApi } from "../../../api/category/khoiNganhApi";

export function* khoiNganhSaga(): any {
  yield takeLatest(eDmKhoiNganhActionIds.LOAD_START, loadWorker);
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(khoiNganhApi.SelectAll);
  if (res.is_success) {
    yield put(rootActions.category.khoiNganh.LOAD_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.category.khoiNganh.LOAD_ERRR(res.message ?? "Có lỗi")
    );
  }
}
